import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import DimensionPeriod from "./DimensionPeriod";
import DimensionPeriodAccordian from "./DimensionPeriodAccordian";
import { complexQuery, getDateFromEpoch } from "../../../Utils/Common/Library";
import { constants } from "./Data/QueryConstants";

function Dimension({
  EmployeePerformancePlanID,
  DimensionID,
  DimensionName,
  DimensionPhase,
  handleTabEdit,
  setPlanStore,
  planStore,
  dimensionData,
}) {
  const [loading, setLoading] = useState(false);
  const [dimensionPeriods, setDimensionPeriods] = useState([]);

  useEffect(() => {
    if (!dimensionData[DimensionID]) {
      setLoading(true);
      complexQuery({
        RequiredFields: [{ EmployeePerformancePlanID }, { DimensionID }],
        QueryName: constants.QueryName,
      })
        .then((response) => {
          setDimensionPeriods(response);
          setPlanStore((prevState) => ({
            ...prevState,
            Dimensions: { ...prevState.Dimensions, [DimensionID]: response[0] },
          }));
        })
        .finally(() => {
          setLoading(false);
        });
    } else {
      setDimensionPeriods([dimensionData[DimensionID]]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return loading || !dimensionPeriods ? (
    <div className="Flex">
      <Typography variant="body1">
        Please wait while we prepare your parameters ...
      </Typography>
    </div>
  ) : (
    <div>
      {dimensionPeriods.map((dimensionPeriod) => {
        dimensionPeriod.DimensionName = DimensionName;
        dimensionPeriod.DimensionPhase = DimensionPhase;

        const PeriodStartDate = getDateFromEpoch({
          epoch: dimensionPeriod.PeriodStartTimestamp,
          returnNthString: true,
        });
        const PeriodEndDate = getDateFromEpoch({
          epoch: dimensionPeriod.PeriodEndTimestamp,
          returnNthString: true,
        });
        return dimensionPeriod ? (
          <DimensionPeriodAccordian
            PeriodTime={`${PeriodStartDate} - ${PeriodEndDate}`}
          >
            <DimensionPeriod
              DimensionPeriodData={dimensionPeriod}
              planStore={planStore}
              key={dimensionPeriod.TransactionID}
              handleTabEdit={handleTabEdit}
              deleteDimensionData={() => {
                setPlanStore((prevState) => {
                  const newState = { ...prevState };
                  const newDimensions = { ...newState.Dimensions };
                  delete newDimensions[dimensionPeriod.DimensionID];
                  newState.Dimensions = newDimensions;
                  return newState;
                });
              }}
            />
          </DimensionPeriodAccordian>
        ) : (
          <></>
        );
      })}
    </div>
  );
}

export default Dimension;
